function initModalSpanDialog() {
    $('#modal-span-dialog').on('shown.bs.modal', function (e) {
      updateSpanTable();
    });

    $('#span-form').validate({ // initialize the plugin
        // other options
    });

    $.validator.addClassRules('new-span-input', {
        required: true,
        validLengthUnit: true
    });
}

function updateSpanTable() {
    var str = "<table class='table'>";
    for( var i = 0; i < activeProject.beam.spans.length; i++ ) {
        var span_num = i + 1;
        str += "<tr>";
        str += "<td style='width:100px;'>Span "+ span_num + "</td>";
        str += "<td><input class='ws-ui-input-load new-span-input' style='width:100px;' id='span_input_"+i+"' type='text' name='new_span' ";
        str += "value='" + showLengthWithUnits(activeProject.beam.spans[i].length(), true) + "' onchange='updateSpan("+i+");'/></td>";
        str += "<td><button type='button' class='btn btn-sm btn-danger' onclick='removeSpan("+i+");'>Remove</button></td></tr>";
        $("#span_input_"+i).removeClass('ui-state-error');
    }
    str += "</table>";

    $('#span-table').html(str);
    $('#modal-span-dialog').trigger( 'span-table-updated' );
}

function openModalSpanDialog(index) {
    $('#modal-span-dialog').modal('show');
    //put cursor in this input box if the id has been passed in
    if( typeof index !== undefined && index !== null ){
        //get this item's index
        if( index < 0 || index >= activeProject.beam.spans.length ) return alert( "Span not found!");
        $('#modal-span-dialog').on('shown.bs.modal', function () {
            $("#span_input_"+index).focus();
        });
    }
    return 0;
}

function removeSpan( index ) {
    activeProject.beamController.RemoveSpan( index );
    updateSpanTable();
    autoBeamFlexureDesign();
}

function addLeftSpan() {
    var len = activeProject.beam.spans[0].length();
    if( !isNaN(len) ){
        activeProject.beamController.AddLeftSpan( len );
        updateSpanTable();
        $('#modal-span-dialog').find("#span_input_0").focus();
    }
}

function addRightSpan() {
    var i_end = activeProject.beam.spans.length;
    var len = activeProject.beam.spans[i_end-1].length();
    if( !isNaN(len) ){
        activeProject.beamController.AddRightSpan( len );
        updateSpanTable();
        $('#modal-span-dialog').find("#span_input_"+i_end).focus();
    }
}

function updateSpan( index ) {
    if ($("#span_input_" + index).valid()) {
        var len = $("#span_input_" + index).val();
        len = wsParseLength( len );
        activeProject.beamController.modifySpan( index, len );
        autoBeamFlexureDesign();
        $('#modal-span-dialog').trigger( 'span-length-changed' );

    }
}
